module.exports = __webpack_public_path__ + "static/media/ActiveNextButton.c2b709b3.svg";